// Fixed Assets State

export default {
  fixedAssetsList: [],
  fixedAssetInfo: {},
  fullFixedAssetsList: [],
  fullTransferFixedAssetsList: []
}
